import { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Phone, MessageCircle, PenLine } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-cream pb-[76px] lg:pb-0">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <div
        data-testid="mobile-action-bar"
        className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 gap-2 border-t border-forest/10 bg-cream/95 p-3 backdrop-blur-xl lg:hidden"
      >
        <a href="tel:+917975094721" data-testid="mobile-call-button" className="flex items-center justify-center gap-2 rounded-full bg-forest py-3 font-display text-sm font-medium text-cream active:scale-[0.97]">
          <Phone className="h-4 w-4" /> Call
        </a>
        <a href="https://wa.me/917975094721" target="_blank" rel="noreferrer" data-testid="mobile-whatsapp-button" className="flex items-center justify-center gap-2 rounded-full bg-[#1FA855] py-3 font-display text-sm font-medium text-white active:scale-[0.97]">
          <MessageCircle className="h-4 w-4" /> WhatsApp
        </a>
        <Link to="/contact" data-testid="mobile-enquire-button" className="flex items-center justify-center gap-2 rounded-full bg-terracotta py-3 font-display text-sm font-medium text-white active:scale-[0.97]">
          <PenLine className="h-4 w-4" /> Enquire
        </Link>
      </div>
    </div>
  );
}
